<template>
  <div class="holiday-rank-root" :class="{ 'no-sort': !(prize1 && prize1.rank) }">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="title" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <span class="tit-right" @click="handleToRule">
            <img class="left-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
          </span>
        </template>
      </van-nav-bar>
    </div>

    <div class="rank-bg" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <img v-if="prize1.rank" src="./images/rank-bg.png" />
      <img v-else src="./images/norank-bg.png" />
    </div>

    <div class="bg-block">
      <div v-if="prize1.rank" class="national-rank-bar">
        <div class="prize">
          <div class="two" v-if="!isEmptyObject(prize2)">
            <img class="rank_c2_avatar" :src="prize2.avatar | imgPath" alt="" />
            <div class="rank-sort">
              <img src="./images/n-two.png" />
            </div>
            <div class="item-num">
              <span class="name">{{ prize2.nickname }}</span>
              <span class="num">
                {{ prize2.score }}
                <i>({{ $t('lang.valRuFe.points') }})</i>
              </span>
            </div>
          </div>

          <div class="prize-gap"></div>

          <div class="one" v-if="!isEmptyObject(prize1)">
            <img class="rank_c1_avatar" :src="prize1.avatar | imgPath" alt="" />
            <div class="rank-sort">
              <img src="./images/n-one.png" />
            </div>
            <div class="item-num">
              <span class="name">{{ prize1.nickname }}</span>
              <span class="num">
                {{ prize1.score }}
                <i>({{ $t('lang.valRuFe.points') }})</i>
              </span>
            </div>
          </div>

          <div class="prize-gap"></div>

          <div class="three" v-if="!isEmptyObject(prize3)">
            <img class="rank_c3_avatar" :src="prize3.avatar | imgPath" alt="" />
            <div class="rank-sort">
              <img src="./images/n-three.png" />
            </div>
            <div class="item-num kiss-num3">
              <span class="name">{{ prize3.nickname }}</span>
              <span class="num">
                {{ prize3.score }}
                <i>({{ $t('lang.valRuFe.points') }})</i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="national-rank-con">
        <div v-if="prize1.rank" class="rank-special-head" :style="{ top: `${barHeight + 44 + 16}px` }">
          <div class="rank-sty-bg2">
            <div class="rank-sty-bg3"></div>
          </div>
        </div>
        <div class="rank-body">
          <template v-if="!prize1.rank">
            <!-- <div class="tit-time">
              <span class="time">xxxx</span>
            </div> -->
            <div class="time-tips first-tip">{{ $t('lang.commonM.k337') }}</div>
            <div class="time-tips">{{ $t('lang.commonM.k252') }}</div>
          </template>
          <template v-else>
            <div class="time-tips tips-end">{{ $t('lang.commonM.k242') }}</div>
          </template>
          <template v-if="rankList.length > 0">
            <div class="agent-item" v-for="item in rankList" :key="item">
              <span class="rank-num" v-if="item.rank">{{ item.rank }}</span>
              <div class="avatar rank-avatar">
                <img :src="item.avatar | imgPath" alt="" />
                <span>{{ item.nickname }}</span>
              </div>
              <div class="item-num">
                {{ item.score }}
                <i>{{ $t('lang.valRuFe.points') }}</i>
              </div>
            </div>
          </template>
        </div>
        <div class="agent-item owner-item" v-if="owners" :style="{ 'margin-bottom': `${bottomBarHeight}px` }">
          <div class="owner-item-content">
            <div class="avatar">
              <span v-if="owners.rank" class="rank-num">{{ owners.rank }}</span>
              <span v-else class="rank-num not-in-rank">--</span>
              <div class="avatar-box">
                <img :src="owners.avatar | imgPath" alt="" />
                <div class="avatar-txt">
                  <span>{{ owners.nickname }}</span>
                  <div v-if="!owners.rank">{{ $t('lang.ween.noRanking') }}</div>
                </div>
              </div>
            </div>
            <div class="item-num">
              {{ owners.score || 0 }}
              <i>{{ $t('lang.valRuFe.points') }}</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo, holidayActRank } from './apidir/api.js'

export default {
  data() {
    return {
      bottomBarHeight: 0,
      rankList: [],
      owners: {},
      showRules: false,
      prize1: {},
      prize2: {},
      prize3: {},
      title: ''
    }
  },
  methods: {
    handleBack() {
      if (this.$route.query.from === 'halloween2025-main-female') {
        this.goPrevious()
        return
      }
      this.closeWeb()
    },
    // 规则
    handleToRule() {
      this.$router.push({ path: '/halloween2025-rules-female', query: { from: 'halloween2025-rank-female' } })
    },
    // 关闭规则
    closeRlueDia() {
      this.showRules = false
    },
    // 获取数据
    fatchRanking() {
      holidayActRank().then((resData) => {
        if (resData) {
          // 排名数据
          if (resData.ranks && resData.ranks.length > 0) {
            // 前三名
            this.prize1 = resData.ranks[0] || {}
            this.prize2 = resData.ranks[1] || {}
            this.prize3 = resData.ranks[2] || {}

            // 已排名
            if (this.prize1.rank) {
              this.rankList = resData.ranks && resData.ranks.slice(3)
            }
            // 未排名
            else {
              this.rankList = resData.ranks
            }
          }

          // 用户数据
          if (resData.owners) {
            this.owners = resData.owners
          }
        }
      })
    },
    // 模拟数据
    mockRanking() {
      const resData = {
        owners: {
          avatar: 'public/picture/2023-07-07/acf4942604ecae168398d19c38d92423.jpg',
          gifts: 0,
          nickname: 'Greenwalt',
          points: 0,
          presentId: '1079',
          uid: 1079,
          rank: 4
        },
        ranks: [
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            rank: 0
          },
          {
            avatar: 'public/app/picture/250811/1754894841342f450882ee3d50e52R7896.jpg',
            gifts: 13,
            nickname: '786err',
            presentId: '2668406',
            uid: 4817,
            rank: 2
          },
          {
            avatar: 'public/app/picture/250322/17426127406309b7cdeac-9ea6-4467-b9c8-d94bdc690d4dR3378.jpg',
            gifts: 12,
            nickname: '452hshd',
            presentId: '9360241',
            uid: 4001,
            rank: 3
          },
          {
            avatar: 'public/app/picture/250322/1742610682602e1d496b8-7c2d-4929-8c89-fca80b541349R1592.jpg',
            gifts: 10,
            nickname: '450shs',
            presentId: '5860232',
            uid: 4000,
            rank: 4
          }
        ]
      }

      if (resData) {
        // 排名数据
        if (resData.ranks && resData.ranks.length > 0) {
          // 活动最后一天 用points， 前几天用gifts
          resData.ranks.forEach((rankItem) => {
            rankItem.score = rankItem.gifts || rankItem.points
          })

          // 前三名
          this.prize1 = resData.ranks[0] || {}
          this.prize2 = resData.ranks[1] || {}
          this.prize3 = resData.ranks[2] || {}

          // 已排名
          if (this.prize1.rank) {
            this.rankList = resData.ranks && resData.ranks.slice(3)
          }
          // 未排名
          else {
            this.rankList = resData.ranks
          }
        }

        // 用户数据
        if (resData.owners) {
          this.owners = resData.owners
        }
      }
    },
    getBaseInfo() {
      holidayActBaseInfo().then((resData) => {
        // 初始化倒计时
        if (resData.countdown < 0 && !resData.started) {
          this.title = this.$t('lang.commonM.k229')
        }
        //
        else {
          this.title = this.$t('lang.commonM.k241')
        }
      })
    }
  },
  created() {
    this.getBaseInfo()
    this.fatchRanking()
    // this.mockRanking()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })
  }
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.holiday-rank-root {
  width: 100%;
  min-height: 100vh;
  background: #29093c;

  .custom-nav-block {
    background: url(./images/rank-bg.png) top left / 100% auto no-repeat;
  }

  .rank-bg {
    width: 100%;
    position: relative;
    img {
      width: 100%;
    }
  }

  .bg-block {
    position: relative;

    .national-rank-bar {
      position: relative;
      margin-bottom: 12px;
      .prize {
        width: 100%;
        margin: 0 auto;
        padding: 0 28px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        .prize-gap {
          width: 11px;
        }
        .one,
        .two,
        .three {
          width: 90px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          padding: 8px 0;
          border-radius: 8px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);

          .item-num {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .name {
              font-size: 15px;
              padding: 0 6px;
              color: #fbf3f1;
              margin-top: 8px;
              width: 100%;
              overflow: hidden;
              text-align: center;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .num {
              margin-top: 10px;
              display: flex;
              align-items: center;
              font-family: 'TikTok Sans';
              font-weight: 600;
              font-size: 17px;
              color: #fbf3f1;
              text-align: center;
              display: inline-flex;
              align-items: center;

              i {
                font-weight: 400;
                font-size: 12px;
              }
            }
          }
        }
        .one {
          .rank_c1_avatar {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #ffcd55;
          }
          .rank-sort {
            width: 70px;
            margin-top: 8px;
            img {
              width: 100%;
            }
          }
        }
        .two {
          .rank_c2_avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #dadee7;
          }
          .rank-sort {
            width: 60px;
            margin-top: 8px;
            img {
              width: 100%;
            }
          }
        }
        .three {
          .rank_c3_avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #d39d58;
          }
          .rank-sort {
            width: 60px;
            margin-top: 8px;
            img {
              width: 100%;
            }
          }
        }
      }
    }

    .national-rank-con {
      min-height: 80vh;
      padding-bottom: 90px;
      .rank-special-head {
        width: 371px;
        height: 36px;
        margin: 0 auto;
        background: #5b2856;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        .rank-sty-bg2 {
          width: 367px;
          height: 32px;
          border: 0.5px solid rgba(255, 255, 255, 0.5);
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          .rank-sty-bg3 {
            width: 351px;
            height: 10px;
            background: linear-gradient(180deg, #29093c 0%, #451e41 50%);
            border-radius: 5px;
          }
        }
      }
      .rank-body {
        width: 343px;
        min-height: 450px;
        margin: -18px auto 0;
        padding: 16px;
        background-color: #442753;
        border-radius: 0px 0px 16px 16px;
        position: relative;
        .tit-time {
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 18px;
          line-height: 18px;
          color: #d7cae1;
          overflow: hidden;
          margin-bottom: 12px;
          .time {
            float: right;
          }
        }
        .time-tips {
          font-family: Inter;
          font-weight: 400;
          font-size: 13px;
          color: #d7cae1;
          line-height: 16px;
          margin-bottom: 16px;
          text-align: center;
        }
        .first-tip {
          margin-bottom: 5px;
        }
        .tips-end {
          font-size: 15px;
          color: #d7cae1;
          letter-spacing: -0.5px;
        }
      }
      .agent-item {
        height: 40px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: Inter;
        &:last-child {
          margin-bottom: 0;
        }
        .rank-num {
          display: block;
          min-width: 18px;
          margin-right: 10px;
          font-family: TikTok Sans;
          font-weight: 500;
          font-size: 16px;
          color: #d7cae1;
        }
        .avatar {
          display: flex;
          align-items: center;
          font-size: 15px;
          font-family: TikTok Sans;
          color: #d7cae1;
          > img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
            object-fit: cover;
          }
        }
        .rank-avatar {
          flex: 1 !important;
        }
        .item-num {
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 20px;
          color: #f8a348;
          font-family: TikTok Sans;
          > img {
            width: 28px;
            height: 25px;
            margin-left: 10px;
          }
          i {
            font-weight: 400;
            padding-left: 6px;
            font-size: 14px;
            color: #d7cae1;
          }
        }
      }
      .owner-item {
        width: 375px;
        height: 69px;
        position: fixed;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        background-color: #5b2856;
        .owner-item-content {
          width: 343px;
          height: 100%;
          margin: 0 auto;
          padding: 16px 9px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .avatar {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            .rank-num {
              font-size: 24px;
              font-weight: 600;
              color: #d7cae1;
            }
            .not-in-rank {
              font-size: 17px;
            }
            .avatar-box {
              display: flex;
              align-items: center;
              > img {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                object-fit: cover;
              }
              .avatar-txt {
                display: inline-block;
                width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 10px;
                font-family: Inter;
                font-weight: normal;
                color: #d7cae1;
                span {
                  font-size: 17px;
                  line-height: 20px;
                }
                div {
                  font-size: 12px;
                  line-height: 16px;
                }
              }
            }
          }
          .item-num {
            color: #d7cae1;
            i {
              color: #d7cae1;
            }
          }
        }
      }
    }
  }
}

.holiday-rank-root.no-sort {
  .custom-nav-block {
    background: url(./images/norank-bg.png) top left / 100% auto no-repeat;
  }
  .rank-bg {
    width: 100%;
    height: fit-content;
    position: relative;

    img {
      width: 100%;
    }
  }

  .bg-block {
    position: relative;
    margin-top: -100px;
    .national-rank-con {
      .rank-body {
        border-radius: 16px;
        margin: 0 auto;
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'TikTok Sans';
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
